import { FolderSimpleDashedIcon } from '@phosphor-icons/react';
import { createBrowserRouter, type RouteObject } from 'react-router';
import { LoginPage } from '../features/auth/LoginPage';
import { SetupPage } from '../features/auth/SetupPage';
import { lazyNamed, PageBody } from '../features/common';
import { TodayPage } from '../features/home/TodayPage';
import { NotificationsPage } from '../features/notifications';
import { SchedaPage, SchedaTabRoute } from '../features/pages/SchedaPage';
import { SchedeListPage } from '../features/pages/SchedeListPage';
import { moduleRoutes, schedaTabs } from '../features/registry';
import { ButtonLink, EmptyState } from '../ui';
import { AppLayout } from './AppLayout';
import { RequireAuth } from './RequireAuth';

function NotFound() {
  return (
    <PageBody className="pt-10">
      <EmptyState
        icon={FolderSimpleDashedIcon}
        title="Pagina non trovata"
        message="Il link potrebbe essere sbagliato o la pagina non esiste più."
        action={<ButtonLink to="/">Torna a Oggi</ButtonLink>}
      />
    </PageBody>
  );
}

const KitPage = lazyNamed(() => import('../kit/KitPage'), 'KitPage');

const routes: RouteObject[] = [
  { path: '/configura', element: <SetupPage /> },
  { path: '/accedi', element: <LoginPage /> },
  ...(import.meta.env.DEV ? [{ path: '/kit', element: <KitPage /> }] : []),
  {
    path: '/',
    element: (
      <RequireAuth>
        <AppLayout />
      </RequireAuth>
    ),
    children: [
      { index: true, element: <TodayPage /> },
      { path: 'schede', element: <SchedeListPage /> },
      {
        path: 'schede/:slug',
        element: <SchedaPage />,
        children: schedaTabs.map((tab) =>
          tab.id
            ? { path: tab.id, element: <SchedaTabRoute tab={tab} /> }
            : { index: true, element: <SchedaTabRoute tab={tab} /> },
        ),
      },
      { path: 'notifiche', element: <NotificationsPage /> },
      ...moduleRoutes,
      { path: '*', element: <NotFound /> },
    ],
  },
];

export const router = createBrowserRouter(routes);
